import { generateNewAccessToken, performLogout } from 'app/helpers/authHelper';
import axios from 'axios';
import store from 'store/index';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_DOMAIN_API,
});

export default instance;

// Will run for every response axios gets
instance.interceptors.response.use(
  // Handle successful responses
  // Pass the response through without any changes
  async response => {
    return response;
  },
  // Handle errors
  async error => {
    // Get the HTTP status code from the error response
    // Avoid crashing with || {} if anything is missing
    let status = ((error || {}).response || {}).status;

    // Save the original request that failed
    const originalRequest = error.config;

    // Store the full error response if available
    const response = error?.response;

    // Store URL
    const url = response?.config?.url;

    // If the error is 401 Unauthorized, and we haven’t already retried this request (prevents infinite loops)
    if (status === 401 && !originalRequest._retry) {
      // Mark the request as retried to prevent infinite loops
      originalRequest._retry = true;

      // If the failing URL does not belong to Allauth, we proceed to handle it as a real error
      if (!url?.includes('allauth/')) {
        // If the failed request is trying to refresh the token, it means the refresh token is no longer valid
        if (url?.includes('token/refresh/')) {
          // Logout the user and stop retrying.
          performLogout();
          return Promise.reject(error);
        }
        try {
          // Generate new access token and retry the request.
          const newAccessToken = await generateNewAccessToken(store.dispatch);
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return instance(originalRequest);
        } catch (refreshError) {
          // Handle any error.
          performLogout();
        }
      }
      console.log('error: ', error);
    }

    return Promise.reject(error);
  },
);

export async function httpRequestWithAuth(url, method, data, params, headers) {
  let feedback;
  try {
    feedback = await instance(url, {
      method: method,
      data,
      params,
      headers,
    })
      .then(res => {
        return { status: true, data: res.data };
      })
      .catch(error => {
        return {
          status: false,
          error_feedback: error.response.data || {
            non_field_errors: 'Ops, Something went wrong',
          },
        };
      });
  } catch (e) {
    feedback = {
      status: false,
      fatal_error: true,
      msg: 'Something went wrong, try again',
      error_feedback: { non_field_errors: 'Ops, Something went wrong' },
    };
  }

  return feedback;
}
